import { useEffect, useMemo, useRef, useState } from "react";
import { useSettlementStore } from "../store";
import { COL, ROW } from "../contanst";
import { TableEditorProps } from "../dto";
import { ResizeGridProps } from "../plugins/resize-grid/dto";

const useResizeGrid = (onResize?: TableEditorProps["onResize"]) => {
  const [{ action, config }, { setAction, setConfig }] = useSettlementStore();
  const [rows, setRows] = useState<number[]>([]);
  const tableRef = useRef<HTMLTableElement>();

  const cols = useMemo(
    () => config.cols?.map((i) => i) ?? [],
    [JSON.stringify(config.cols)]
  );

  const reset = () => {
    setRows(
      config.rows.map(
        (i) =>
          tableRef.current
            ?.querySelector(`tr[data-id="${i.id}"]`)
            ?.getBoundingClientRect()?.height ?? i.height
      )
    );
  };

  // 可能出现宽度小于内容出现换行导致的高度变化，因此需要通过dom获取高度&需要监听宽度变化
  useEffect(reset, [JSON.stringify(config.rows), JSON.stringify(config.cols)]);

  const onResizeStart = () => setAction("resize");
  const onResizeEnd = () => setAction("none");
  const onChange: ResizeGridProps["onChange"] = (opt) => {
    const { type, index, offset } = opt;
    setConfig((cfg) => {
      if (type === "col") {
        cfg.cols[index] = Math.min(
          Math.max(cfg.cols[index] + offset, COL.MIN_WIDTH),
          COL.MAX_WIDTH
        );
      }
      if (type === "row") {
        cfg.rows[index].height = Math.min(
          Math.max(cfg.rows[index].height + offset, ROW.MIN_HEIGHT),
          ROW.MAX_HEIGHT
        );
      }
    });
    onResize?.(opt);
  };

  const setRef = (node) => {
    tableRef.current = node;
  };

  return [
    setRef,
    {
      cols,
      rows,
      enable: action === "none",
      onResizeStart,
      onResizeEnd,
      onChange,
    },
  ] as const;
};

export default useResizeGrid;
